import styles from "./MarathonHeroSection.module.css";
import {MyButton} from "../../../common";
import sectionImage from "../../../../assets/images/pages/ParentsMarathon/section-1-img.png"
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import { useState } from "react";
import { COOKIE_KEY, RootState, selectStore } from "../../../../utils";
import { useSelector } from "react-redux";
import {Cookies} from "react-cookie";
import { ConsultationFormModal } from "../../../popups/ConsulationPopup/ConsultationPopup";

const QuestionCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#FF9500"/>
    <path d="M9.08984 8.99996C9.32495 8.33163 9.789 7.76807 10.3998 7.40909C11.0106 7.05012 11.7287 6.9189 12.427 7.03867C13.1253 7.15844 13.7587 7.52148 14.2149 8.06349C14.6712 8.60549 14.9209 9.29148 14.9198 9.99996C14.9198 12 11.9198 13 11.9198 13M12 17H12.01" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export const ButtonIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M17.3333 12L21.3333 16M21.3333 16L17.3333 20M21.3333 16H10.6667M28 16C28 17.5759 27.6896 19.1363 27.0866 20.5922C26.4835 22.0481 25.5996 23.371 24.4853 24.4853C23.371 25.5996 22.0481 26.4835 20.5922 27.0866C19.1363 27.6896 17.5759 28 16 28C14.4241 28 12.8637 27.6896 11.4078 27.0866C9.95189 26.4835 8.62902 25.5996 7.51472 24.4853C6.40042 23.371 5.5165 22.0481 4.91345 20.5922C4.31039 19.1363 4 17.5759 4 16C4 12.8174 5.26428 9.76516 7.51472 7.51472C9.76516 5.26428 12.8174 4 16 4C19.1826 4 22.2348 5.26428 24.4853 7.51472C26.7357 9.76516 28 12.8174 28 16Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

export const ButtonSecondIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M12.5078 12.4C12.7899 11.598 13.3468 10.9217 14.0798 10.4909C14.8127 10.0601 15.6745 9.90268 16.5124 10.0464C17.3504 10.1901 18.1104 10.6258 18.6579 11.2762C19.2054 11.9266 19.5051 12.7498 19.5038 13.6C19.5038 16 15.9038 17.2 15.9038 17.2M16 22H16.012M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)


const LIST_ITEMS = [
  "Ваш ребёнок молчит",
  "Не говорит даже «мама» и «дай»",
  "Вы беспокоитесь, но не знаете, с чего начать",
] as const;

export const MarathonHeroSection = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [canSelectSpecialist, setCanSelectSpecialist] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { profile: { userData: userDataState, specialistsData: specialistsState}}: RootState = useSelector(selectStore);
  const cookies = new Cookies()
  const specialists = Array.isArray(specialistsState?.data)
  ? specialistsState.data
  : [];
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  const showModal = () => {
    console.log("showModal вызван");
    setIsModalVisible(true);
    setCanSelectSpecialist(true);
  };

  const handleOk = () => setIsModalVisible(false);
  const handleCancel = () => {
    setIsModalVisible(false);
    setCanSelectSpecialist(false);
  };
  

  const embeddedNavigate = useEmbeddedNavigate();
  return (
    <section className={styles.hero} id="hero" aria-label="Марафон запуска речи">
      <div className={styles.container}>
        <div className={styles.content}>
          <span className={styles.badge}>Марафон для родителей</span>

          <h1 className={styles.title}>
            Месяц запуска речи:
            <br />
            заговори со мной!
          </h1>

          <ul className={styles.list}>
            {LIST_ITEMS.map((item) => (
              <li key={item} className={styles.listItem}>
                <QuestionCircle />
                <span className={styles.listText}>{item}</span>
              </li>
            ))}
          </ul>

          <p className={styles.description}>
            Приглашаем вас на практический марафон, который поможет стимулировать
            речь у ребёнка в домашних условиях — без сложных методик и дорогих
            специалистов.
          </p>

          <div className={styles.buttons}>
            <MyButton color="orange" type="primary" onClick={() => embeddedNavigate("/diagnostics-marathon")}>
              Начать марафон <ButtonIcon />
            </MyButton>


            <MyButton color="blue" type="primary" onClick={() => {
                            if (token) {
                              if (userDataState?.data?.first_name && userDataState?.data?.last_name && userDataState?.data?.region_id) {
                                showModal();
                              } else {
                                embeddedNavigate('/register/confirm');
                              }
                            } else {
                              embeddedNavigate('/auth');
                            }
                          }}>
              Задать вопрос <ButtonSecondIcon />
            </MyButton>
          </div>
        </div>

        <img src={sectionImage} alt="first-section-image"/>
      </div>
      <ConsultationFormModal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} specialists={specialists} selectedItem={selectedItem}  canSelectSpecialist={canSelectSpecialist}/>
      
    </section>
  );
};